// Copyright (c) 2016 Deere & Company

import {routerActions} from 'react-router-redux';

export const goToNewTransfer = pin =>
    routerActions.push(`/products/new-transfer/${pin}`);



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/new-transfer-view.js